export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bk-bets.vue?vue&type=template&id=2e19e5f0&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/bk-bets.vue?vue&type=template&id=2e19e5f0&scoped=true
// module id = xlw6
// module chunks = 0